import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	portalLabel: {
		id: 'servicedesk.channels-jsd.channels.help-center.portal-label',
		defaultMessage: 'PORTAL',
		description: 'Name of portal channel',
	},
	label: {
		id: 'servicedesk.channels-jsd.channels.help-center.label',
		defaultMessage: 'Portal',
		description: 'Name of portal channel',
	},
	helpCenterButtonLabel: {
		id: 'servicedesk.channels-jsd.channels.help-center.help-center-button-label',
		defaultMessage: 'Open Help Center',
		description: 'Name of help center button',
	},
	open: {
		id: 'servicedesk.channels-jsd.channels.help-center.open',
		defaultMessage: 'Open',
		description: 'Label on the button to open help center in a new tab',
	},
	openButtonLabelDescriptive: {
		id: 'servicedesk.channels-jsd.channels.help-center.open.label-descriptive',
		defaultMessage: 'Open portal',
		description: 'Open a portal',
	},
	portalVisibleLabel: {
		id: 'servicedesk.channels-jsd.channels.help-center.portal-visible-label',
		defaultMessage: 'VISIBLE',
		description: 'Status of the portal, states if it is visible to the customers',
	},
	portalHiddenLabel: {
		id: 'servicedesk.channels-jsd.channels.help-center.portal-hidden-label',
		defaultMessage: 'HIDDEN',
		description: 'Status of the portal, states if it is hidden from the customers',
	},
	portalHidden: {
		id: 'servicedesk.channels-jsd.channels.help-center.portal-hidden',
		defaultMessage: 'Hidden',
		description: 'Status of the portal, states if it is hidden from the customers',
	},
});
